import { render, staticRenderFns } from "./ConvenioDialog.vue?vue&type=template&id=5e4822a1"
import script from "./ConvenioDialog.vue?vue&type=script&lang=js"
export * from "./ConvenioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports